import React, { FC } from "react";
import { FormRow } from "../forms/FormRow";
import { TagsInput } from "../general/TagsInput/TagsInput";
import styles from "./MemberManagement.module.scss";
import { ConfigurePermissionsFields } from "./ConfigurePermissionsFields";
import { TeamFormProps } from "./types";

export const AddTeamFields: FC<TeamFormProps> = ({ workspace, entities }) => (
    <>
        <section className={styles.section}>
            <header className={styles.sectionHeader}>
                <h6 className={styles.sectionTitle}>Email addresses</h6>
            </header>

            <div>
                <FormRow fieldName="emails">
                    <TagsInput
                        name="emails"
                        placeholder="Emails, comma separated"
                        size="sm"
                    />
                </FormRow>
            </div>
        </section>

        <ConfigurePermissionsFields workspace={workspace} entities={entities} />
    </>
);
